export class HtmlWebClientException extends Error {
  constructor(message) {
    super(message);
  }
}
